import { createPinia } from 'pinia'

// Setup Pinia
// https://pinia.esm.dev/
const store = createPinia()
export default store
